import { render, staticRenderFns } from "./card-paymethod.vue?vue&type=template&id=67036c01&scoped=true"
import script from "./card-paymethod.vue?vue&type=script&lang=js"
export * from "./card-paymethod.vue?vue&type=script&lang=js"
import style0 from "./card-paymethod.vue?vue&type=style&index=0&id=67036c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67036c01",
  null
  
)

export default component.exports